import React from "react";
import Layout from "../../components/Layout";

const PrivacyPolicyPage = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-[#f5f3ee] flex items-center justify-center p-6">
        <div className="max-w-4xl w-full bg-white shadow-2xl rounded-2xl p-10">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-6">Məxfilik Siyasəti</h1>
          
          <p className="text-gray-700 mb-4">
            Tixy.az istifadəçilərinin şəxsi məlumatlarının təhlükəsizliyini qorumağa sadiqdir.
            Bu Məxfilik Siyasəti sizin hansı məlumatların toplandığını, necə istifadə olunduğunu və qorunduğunu izah edir.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-2">Toplanan Məlumatlar</h2>
          <p className="text-gray-700 mb-4">
            Saytımızda qeydiyyat, bilet sifarişi və digər fəaliyyətlər zamanı ad, soyad, email ünvanı, telefon nömrəsi və ödəniş məlumatları toplanıla bilər.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-2">Məlumatların İstifadəsi</h2>
          <p className="text-gray-700 mb-4">
            Toplanmış məlumatlar xidmətlərin göstərilməsi, sifarişlərin icrası, istifadəçi dəstəyi və xidmət təkmilləşdirilməsi üçün istifadə olunur.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-2">Məlumatların Qorunması</h2>
          <p className="text-gray-700 mb-4">
            Şəxsi məlumatlarınız müasir təhlükəsizlik texnologiyaları və metodları ilə qorunur. Sizin məlumatlarınızın icazəsiz istifadəsinin qarşısını almaq üçün tədbirlər görürük.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-2">Üçüncü Tərəflərlə Paylaşım</h2>
          <p className="text-gray-700 mb-4">
            Şəxsi məlumatlarınız yalnız hüquqi öhdəliklər çərçivəsində və ya sizin razılığınızla üçüncü tərəflərlə paylaşılır.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-2">Əlaqə</h2>
          <p className="text-gray-700">
            Məxfilik siyasətimizlə bağlı sual və ya təklifləriniz varsa, bizimlə <a href="mailto:info@tixy.az" className="text-black underline">info@tixy.az</a> email ünvanı vasitəsilə əlaqə saxlaya bilərsiniz.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicyPage;
